// Resuelve una imagen empaquetada por ruta (p.ej. "icons/i12.png") de forma SEGURA: si la ruta no
// existe en el bundle (un ícono nuevo o con typo escrito desde el panel), NO revienta el render —
// devuelve un placeholder. Sin esto, un require() dinámico con una ruta inexistente lanza
// "Cannot find module" y, sin ErrorBoundary, deja el sitio en blanco.
//
// require.context es una API de webpack (CRA): indexa en build todas las imágenes de assets/images.

const ctx = require.context("../assets/images", true, /\.(png|jpe?g|svg|webp)$/);

let fallback;
try {
  fallback = ctx("./icons/i1.png");
} catch (e) {
  fallback = undefined;
}

export function resolveImage(path) {
  if (!path || typeof path !== "string") return fallback;
  const trimmed = path.trim();
  if (trimmed === "") return fallback;
  // URL absoluta (http/https o protocolo-relativo //), data:, o ruta absoluta servida por el hosting
  // (p.ej. una imagen subida desde el panel a https://incap.edu.mx/media/...): úsala tal cual.
  // 'javascript:' u otros esquemas NO casan aquí y caen a la resolución empaquetada (placeholder).
  if (/^(https?:)?\/\//i.test(trimmed) || trimmed.startsWith("/") || trimmed.startsWith("data:")) {
    return trimmed;
  }
  const key = trimmed.startsWith("./") ? trimmed : `./${trimmed}`;
  try {
    return ctx(key);
  } catch (e) {
    return fallback;
  }
}
